<template>
  <el-carousel indicator-position="none" :height="height"  :autoplay="true" 
    :interval="5000" :loop="true">
    <el-carousel-item v-for="(item,index) in detail"
      v-if="item.times[0] < curTime && curTime < item.times[1]" :key="index">
      <template v-if="item.link">
        <a :href="item.link" target="_blank">
          <el-image :src="aliUrl + item.url"></el-image>
        </a>
      </template>
      <template v-else>
        <el-image :src="aliUrl + item.url"></el-image>
      </template>
    </el-carousel-item>
  </el-carousel>
</template>

<script>
  import {
    aliUrl
  } from '@/utils/app'
  export default {
    props: {
      id: {
        type: Number,
        required: true
      },
      height: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        aliUrl:aliUrl,
        curTime: new Date().getTime(),
        detail: {}
      }
    },
    mounted() {
      this.detail = this.$advs[this.id] ? this.$advs[this.id].content : {}
    }
  }
</script>